import React from "react";

function Header() {
  return (
    <div className="customFooter">
      <span>
        &copy; {1900 + new Date().getYear()}{" "}
        <a href="https://www.siskon.com.tr">Siskon Yazılım & Otomasyon</a>{" "}
        v1.0.20
      </span>
    </div>
  );
}

export default Header;
